import { InputField } from "components/designV2/inputfield/inputfield";
import { useTranslation } from "react-i18next";
import { normalizeNumber } from "web-apps/company/components/common/number.normalize.logic";
import {
  PassSettingControl,
  PassSettingControls,
} from "./passSettingsV2.styled";
import { SystemSettingRow } from "./systemSettingRow.component";

export const BreakSetting: React.FC<{
  value: number;
  onChange: (v: number) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const handleChange = (nextValue: string): void => {
    const normalizedValue = normalizeNumber(nextValue);
    if (normalizedValue !== null) onChange(normalizedValue);
  };

  return (
    <SystemSettingRow
      title={t("System.Break")}
      description={t("System.BreakInfo")}
      controlVerticalAlign="center"
    >
      <PassSettingControls>
        <PassSettingControl>
          <InputField
            ariaLabel={t("System.Break")}
            value={String(value)}
            type="number"
            size="compact"
            onChange={handleChange}
          />
        </PassSettingControl>
      </PassSettingControls>
    </SystemSettingRow>
  );
};
